




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { BAlert, BBadge, BSpinner } from 'bootstrap-vue'
import {
  StaffingUtilisateurDetail,
  StaffingEntrepriseDetail,
  StaffingStatut
} from '@/api/models/staffing/staffing'

@Component({
  components: { BAlert, BBadge, BSpinner },
  name: 'staffing-summary-banner'
})
export default class StaffingSummaryBanner extends Vue {
  @Prop({ required: false, type: String, default: null }) utilisateurId!: string | null
  @Prop({ required: false, type: String, default: null }) entrepriseId!: string | null

  staffing: StaffingUtilisateurDetail | StaffingEntrepriseDetail | null = null
  loading = true

  async mounted() {
    await this.load()
  }

  @Watch('utilisateurId')
  async onUtilisateurIdChange() {
    await this.load()
  }

  @Watch('entrepriseId')
  async onEntrepriseIdChange() {
    await this.load()
  }

  async load() {
    if (!this.$can('STAFFING:read')) return
    this.loading = true
    try {
      if (this.utilisateurId) {
        this.staffing = await this.$http.myressif.utilisateurs.getStaffing(this.utilisateurId)
      } else if (this.entrepriseId) {
        this.staffing = await this.$http.myressif.entreprises.getStaffing(this.entrepriseId)
      }
    } catch {
      this.staffing = null
    } finally {
      this.loading = false
    }
  }

  get actuel(): number {
    if (!this.staffing) return 0
    return 'etpAlloue' in this.staffing ? (this.staffing as StaffingUtilisateurDetail).etpAlloue : (this.staffing as StaffingEntrepriseDetail).etpStaffe
  }

  get cible(): number {
    if (!this.staffing) return 0
    return 'etpContractuel' in this.staffing ? (this.staffing as StaffingUtilisateurDetail).etpContractuel : (this.staffing as StaffingEntrepriseDetail).etpAttendu
  }

  get ecart(): number {
    return Number((this.actuel - this.cible).toFixed(2))
  }

  get ecartSign(): string {
    return this.ecart > 0 ? '+' : ''
  }

  get ecartClass(): string {
    if (this.ecart > 0.05) return 'text-warning font-weight-bold'
    if (this.ecart < -0.05) return 'text-danger font-weight-bold'
    return 'text-success font-weight-bold'
  }

  get pourcentageCompletion(): number {
    if (!this.cible) return 0
    return Math.round((this.actuel / this.cible) * 100)
  }

  get statut(): StaffingStatut {
    if (!this.staffing) return 'ok'
    return this.staffing.statut
  }

  get statutLabel(): string {
    if (this.statut === 'sur') return 'Sur-staffé'
    if (this.statut === 'sous') return 'Incomplet'
    return 'OK'
  }

  get alertVariant(): string {
    if (this.statut === 'sur') return 'warning'
    if (this.statut === 'sous') return 'danger'
    return 'success'
  }

  get badgeVariant(): string {
    if (this.statut === 'sur') return 'warning'
    if (this.statut === 'sous') return 'danger'
    return 'success'
  }

  formatEtp(value: number | undefined | null): string {
    if (value == null || isNaN(value)) return '—'
    return Number(value).toFixed(2)
  }
}
